import { SEGMENT_ORIENTATION, SEGMENT_INF } from "./constants.utils";
import { aggregateProductsQuantities } from "../../Common/utils/func.util";

export const generateNextSegment = (previousSegment, newSegmentType) => {
  // Initial angled position /'\
  // Initial straight position |_'_|
  // Segment contact side for orientation
  // Rotation only in clockwise direction
  // One direction authorized like in the software
  // If previous segment => initial position = previousSegment.position
  // Default orientation is ORIENTATION.EAST
  const newSegment = {
    id: previousSegment ? previousSegment.id + 1 : 1,
    type: newSegmentType,
    position: {
      x: previousSegment ? previousSegment.position.x : 0,
      y: previousSegment ? previousSegment.position.y : 0,
      z: previousSegment ? previousSegment.position.z : 0
    },
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    orientation: SEGMENT_ORIENTATION.EAST,
    isSelected: false,
    startPosition: 0,
    endPosition: 0
  };

  if (!previousSegment) {
    if (newSegmentType === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
      newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 4;
    } else if (newSegmentType === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
      newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 7;
    }
    return newSegment;
  }

  switch (previousSegment.orientation) {
    case SEGMENT_ORIENTATION.WEST:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WEST;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
          newSegment.position.z += 1.6; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WESTNORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
          newSegment.position.z -= 1.6; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= SEGMENT_INF.ANGLED.LOGICAL_LENGTH; // v
        }
      }
      break;
    case SEGMENT_ORIENTATION.NORTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 2;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.NORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.z -= SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= 1.6; // v
          newSegment.position.z -= SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2 + SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 5;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EASTNORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += 1.6;
          newSegment.position.z -= SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2 + SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2;
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.z -= SEGMENT_INF.ANGLED.LOGICAL_LENGTH;
        }
      }
      break;
    case SEGMENT_ORIENTATION.SOUTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 6;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.SOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.z += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += 1.6; // v
          newSegment.position.z += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 13;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WESTSOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.z += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
          newSegment.position.x -= 1.6; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.z += SEGMENT_INF.ANGLED.LOGICAL_LENGTH; // v
        }
      }

      break;
    case SEGMENT_ORIENTATION.WESTNORTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WESTNORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= 21.2; // v
          newSegment.position.z -= 21.2; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= 16; // v
          newSegment.position.z -= 14; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 3;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.NORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= 14; // v
          newSegment.position.z -= 16; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= 9.2; // v
          newSegment.position.z -= 9.2; // v
        }
      }
      break;
    case SEGMENT_ORIENTATION.EASTNORTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 3;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EASTNORTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += 21.2; // v
          newSegment.position.z -= 21.2; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += 14; // v
          newSegment.position.z -= 16; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 7;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EAST;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += 16; // v
          newSegment.position.z -= 14; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += 9.2; // v
          newSegment.position.z -= 9.2; // v
        }
      }
      break;
    case SEGMENT_ORIENTATION.EASTSOUTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 5;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EASTSOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += 21.2; // v
          newSegment.position.z += 21.2; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += 16.5; // v
          newSegment.position.z += 14; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 11;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.SOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += 14; // v
          newSegment.position.z += 16; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += 9.2; // v
          newSegment.position.z += 9.2; // v
        }
      }
      break;
    case SEGMENT_ORIENTATION.WESTSOUTH:
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 7;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WESTSOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= 21.2; // v
          newSegment.position.z += 21.2; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= 14; // v
          newSegment.position.z += 16; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 15;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.WEST;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x -= 16; // v
          newSegment.position.z += 14; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x -= 9.2; // v
          newSegment.position.z += 9.2; // v
        }
      }
      break;
    default:
      // EAST BY DEFAULT
      if (newSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.STRAIGHT.LOGICAL_ROTATION_ANGLE * 4;
        // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EAST;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
          newSegment.position.z -= 1.6; // v
        }
      } else if (newSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        // rotation
        newSegment.rotation.y = SEGMENT_INF.ANGLED.LOGICAL_ROTATION_ANGLE * 9;
        // // orientation
        newSegment.orientation = SEGMENT_ORIENTATION.EASTSOUTH;
        // position
        if (previousSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          newSegment.position.x += SEGMENT_INF.STRAIGHT.LOGICAL_LENGTH / 2 + SEGMENT_INF.ANGLED.LOGICAL_LENGTH / 2; // v
          newSegment.position.z += 1.6; // v
        } else if (previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          newSegment.position.x += SEGMENT_INF.ANGLED.LOGICAL_LENGTH; // v
        }
      }
      break;
  }
  return newSegment;
};

export const checkCanAutoCloseTrack = (track) => {
  // console.log("checkCanAutoCloseTrack") ;
  if (track && track.length > 1 && track[track.length - 1].orientation === SEGMENT_ORIENTATION.WEST) {
    return true;
  }
  return false;
};

function isBetween(value, min, max) {
  // console.log("isBetween");
  const maxValue = max > min ? max : min;
  const minValue = min < max ? min : max;
  return value >= minValue && value <= maxValue;
}

export const checkTrackClosed = (pattern) => {
  // console.log("checkTrackClosed", pattern);
  let isClosed = false;
  const canBeClosed = pattern.filter((s) => s.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE).length > 0;
  if (canBeClosed) {
    const firstSegment = pattern[0];
    const lastSegment = pattern[pattern.length - 1];
    // If it is not the same segment
    if (firstSegment.id !== lastSegment.id) {
      if (firstSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
        isClosed =
          lastSegment.orientation === SEGMENT_ORIENTATION.EASTNORTH &&
          isBetween(lastSegment.position.z, firstSegment.position.z - 15, firstSegment.position.z + 15) &&
          isBetween(lastSegment.position.x, firstSegment.position.x - 32, firstSegment.position.x + 32);
      } else if (firstSegment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        isClosed =
          lastSegment.orientation === SEGMENT_ORIENTATION.EAST &&
          isBetween(lastSegment.position.z, firstSegment.position.z - 15, firstSegment.position.z + 15) &&
          isBetween(lastSegment.position.x, firstSegment.position.x - 32, firstSegment.position.x + 32);
      }
    }
  }
  return isClosed;
};

export const roundNumber = (s) => {
  const n = parseFloat(s);
  if (Number.isNaN(n)) {
    return s;
  }
  if (Number.isInteger(n)) {
    return n;
  }
  return n.toFixed(2);
};

export const howManyXInY = (x, y) => {
  if (x === 0) {
    return y;
  }
  const z = y / x;
  return z >= 1 ? Math.floor(z) : 0;
};

function CalculateStraightGuideRails(availableStraightGuiderails, sequenceLength) {
  // console.log("CalculateStraightGuideRails");
  const tmpStraightGuideRails = [];
  if (sequenceLength <= 0) return tmpStraightGuideRails;
  const ulDescStraightGuiderails = [...availableStraightGuiderails].sort(
    (a, b) => Number(b.generic) - Number(a.generic)
  );
  let y = sequenceLength;
  ulDescStraightGuiderails.forEach((rail) => {
    const howMany = howManyXInY(Number(rail.generic), y);
    if (howMany !== 0) {
      tmpStraightGuideRails.push({
        ...rail,
        quantity: Math.floor(howMany)
      });
      y %= Number(rail.generic);
    }
  });
  return tmpStraightGuideRails;
}

function calculateAngledGuideRail(availableAngledGuiderails, angledPattern) {
  // console.log("calculateAngledGuideRail: ", availableAngledGuiderails, angledPattern);
  if (!angledPattern || angledPattern.length <= 0) return null;
  const angleCount = angledPattern.length * 45;
  const foundGuideRail = availableAngledGuiderails.find((gr) => gr.installationDirection === String(angleCount));
  return {
    ...foundGuideRail,
    quantity: 1
  };
}

function aggregateQuantities(calculatedGuideRails) {
  // console.log("aggregateQuantities");
  const newGalculatedGuideRails = [];
  if (!calculatedGuideRails && calculatedGuideRails.length < 1) {
    return newGalculatedGuideRails;
  }
  calculatedGuideRails.forEach((calcGR) => {
    const occurences = calculatedGuideRails.filter(
      (occ) => occ.installationDirection === calcGR.installationDirection && occ.generic === calcGR.generic
    );
    if (occurences.length === 1) {
      newGalculatedGuideRails.push({
        ...occurences[0],
        quantity: occurences[0].quantity
      });
    } else if (occurences.length > 1) {
      const isExistInNewArray = newGalculatedGuideRails.find(
        (foundedGR) =>
          foundedGR.installationDirection === occurences[0].installationDirection &&
          foundedGR.generic === occurences[0].generic
      );
      if (!isExistInNewArray) {
        let quantitiesSum = 0;
        occurences.forEach((occ) => {
          quantitiesSum += occ.quantity;
        });
        newGalculatedGuideRails.push({
          ...occurences[0],
          quantity: quantitiesSum
        });
      }
    }
  });
  return newGalculatedGuideRails;
}

function extractStraightPatterns(receivedTrack) {
  // console.log("findLongestStraightSequence:", receivedTrack);
  const straightSequences = [];
  let sequence = [];
  // if the track is closed
  if (receivedTrack.isTrackClosed) {
    const lastAngledIndex = receivedTrack.trackPattern.findIndex(
      (segment) => segment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE && segment.orientation === SEGMENT_ORIENTATION.EAST
    );
    // circular loop
    let index = lastAngledIndex + 1;
    while (index !== lastAngledIndex) {
      console.log("index:", index);
      if (index === receivedTrack.trackPattern.length) {
        index = -1;
      } else {
        if (receivedTrack.trackPattern[index].type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
          sequence.push(receivedTrack.trackPattern[index]);
        } else {
          if (sequence.length > 0) {
            straightSequences.push(sequence);
            sequence = [];
          }
        }
      }
      index++;
    }
    // if the track is opened
  } else {
    receivedTrack.trackPattern.forEach((segment) => {
      if (segment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
        sequence.push(segment);
      } else {
        if (sequence.length > 0) {
          straightSequences.push(sequence);
          sequence = [];
        }
      }
    });
  }
  // saving the last segment
  if (sequence.length > 0) {
    straightSequences.push(sequence);
  }

  return straightSequences;
}

function extractAngledPatterns(receivedTrack) {
  // console.log("extractAngledPatterns:", receivedTrack);
  let sequence = [];
  const angledSequences = [];
  const firstStraightIndex = receivedTrack.trackPattern.findIndex(
    (segment) => segment.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE
  );
  const angledSegmentCount = receivedTrack.trackPattern.reduce((acc, segment) => {
    return segment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE ? acc + 1 : acc;
  }, 0);
  // there is no straight segment only angled
  if (firstStraightIndex === -1 && angledSegmentCount !== 0) {
    angledSequences.push(receivedTrack.trackPattern);
  } else if (angledSegmentCount !== 0) {
    // for closed track
    if (receivedTrack.isTrackClosed) {
      // circular loop
      let index = firstStraightIndex;
      do {
        if (index === receivedTrack.trackPattern.length) {
          index = -1;
        } else {
          if (receivedTrack.trackPattern[index].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
            sequence.push(receivedTrack.trackPattern[index]);
          } else {
            if (sequence.length > 0) {
              angledSequences.push(sequence);
              sequence = [];
            }
          }
        }
        index++;
      } while (index !== firstStraightIndex);
      // for opened track
    } else {
      receivedTrack.trackPattern.forEach((segment) => {
        if (segment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
          sequence.push(segment);
        } else {
          if (sequence.length > 0) {
            angledSequences.push(sequence);
            sequence = [];
          }
        }
      });
    }
    // saving the last sequence
    if (sequence.length > 0) {
      angledSequences.push(sequence);
    }
  }
  return angledSequences;
}

function getPreviousSegment(segment, receivedTrack) {
  // console.log("getPreviousSegment:", segment, receivedTrack);
  let previousSegment = receivedTrack.trackPattern.find((s) => s.id === segment.id - 1);
  if (receivedTrack.isTrackClosed && segment.id === 1) {
    previousSegment = receivedTrack.trackPattern[receivedTrack.trackPattern.length - 1];
  }
  return previousSegment;
}

function getNextSegment(segment, receivedTrack) {
  // console.log("getNextSegment:", segment, receivedTrack);
  let nextSegment = receivedTrack.trackPattern.find((s) => s.id === segment.id + 1);
  if (
    receivedTrack.isTrackClosed &&
    segment.id === receivedTrack.trackPattern[receivedTrack.trackPattern.length - 1].id
  ) {
    nextSegment = receivedTrack.trackPattern[0];
  }
  return nextSegment;
}

export const calculateGuideRails = (receivedTrack, guideRails, hardStop) => {
  // console.log("receivedTrack:", receivedTrack, "\nguideRails:", guideRails, "\nhardStop:", hardStop);
  const isTrackOpen = !receivedTrack.isTrackClosed;
  const extractStraightSequences = extractStraightPatterns(receivedTrack);
  const extractAngledSequences = extractAngledPatterns(receivedTrack);
  const calculatedGuideRails = [];
  const isLastSegmentAngled = receivedTrack.trackPattern.at(-1).type === SEGMENT_INF.ANGLED.LOGICAL_TYPE;

  // Straight segments
  extractStraightSequences.forEach((sequence) => {
    const previousSegment = getPreviousSegment(sequence[0], receivedTrack);

    let nbConsecutiveStraight = sequence.length;
    if (previousSegment && previousSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
      nbConsecutiveStraight -= isTrackOpen && isLastSegmentAngled ? 2 : 1;
    } else if (isTrackOpen && isLastSegmentAngled) {
      nbConsecutiveStraight -= 1;
    }

    calculatedGuideRails.push(
      ...CalculateStraightGuideRails(
        guideRails.filter((gr) => gr.installationDirection.toLowerCase() === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE),
        nbConsecutiveStraight
      )
    );
  });

  // Angled segments
  extractAngledSequences.forEach((sequence) => {
    calculatedGuideRails.push(
      calculateAngledGuideRail(
        guideRails.filter((gr) => gr.installationDirection.toLowerCase() !== SEGMENT_INF.STRAIGHT.LOGICAL_TYPE),
        sequence
      )
    );
  });

  if (isTrackOpen) {
    calculatedGuideRails.push({
      ...hardStop,
      installationDirection: "STOP",
      quantity: 1
    });
    // MSC-1716 always add 0.5 to open track
    calculatedGuideRails.push({
      ...guideRails
        .filter((gr) => gr.installationDirection.toLowerCase() === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE)
        .find((gr) => Number(gr.generic) === 0.5),
      quantity: 1
    });
  }

  return aggregateQuantities(calculatedGuideRails);
};

function sumArrayReduce(numbers) {
  return numbers.reduce((acc, num) => acc + num, 0);
}

function straightPrecedence(orientation, precededSegment, nextSegment, isTrackClosed) {
  // console.log("straightPrecedence", orientation, precededSegment, nextSegment, isTrackClosed);
  const overall = { x: 0, y: 0 };
  switch (orientation) {
    case SEGMENT_ORIENTATION.EAST:
    case SEGMENT_ORIENTATION.WEST:
      overall.x = 300.4;
      overall.y = 132.5;
      break;
    case SEGMENT_ORIENTATION.SOUTH:
    case SEGMENT_ORIENTATION.NORTH:
      overall.x = 132.5;
      overall.y = 300.4; // to fix in confluence
      break;
    case SEGMENT_ORIENTATION.WESTNORTH:
    case SEGMENT_ORIENTATION.WESTSOUTH:
    case SEGMENT_ORIENTATION.EASTNORTH:
    case SEGMENT_ORIENTATION.EASTSOUTH:
      if (precededSegment !== null) {
        overall.x = 212.41;
        overall.y = 212.41;
      } else {
        overall.x = 259.26;
        overall.y = 259.26;
      }
      break;
    default:
  }
  return overall;
}

function angledPrecedence(orientation, precededSegment, nextSegment, isTrackClosed) {
  // console.log("angledPrecedence", orientation, precededSegment, nextSegment, isTrackClosed);
  const overall = { x: 0, y: 0 };
  switch (orientation) {
    case SEGMENT_ORIENTATION.EAST:
    case SEGMENT_ORIENTATION.EASTSOUTH:
    case SEGMENT_ORIENTATION.WEST:
    case SEGMENT_ORIENTATION.WESTNORTH:
      overall.x = 94.51;
      if (
        !isTrackClosed &&
        precededSegment !== null &&
        precededSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE &&
        (precededSegment.orientation === SEGMENT_ORIENTATION.WEST ||
          precededSegment.orientation === SEGMENT_ORIENTATION.EAST)
      ) {
        overall.x = 188.2;
      }
      overall.y = 171.65;
      break;
    case SEGMENT_ORIENTATION.SOUTH:
    case SEGMENT_ORIENTATION.NORTH:
    case SEGMENT_ORIENTATION.EASTNORTH:
    case SEGMENT_ORIENTATION.WESTSOUTH:
      overall.x = 171.65;
      overall.y = 94.51;
      if (
        !isTrackClosed &&
        precededSegment !== null &&
        precededSegment.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE &&
        (precededSegment.orientation === SEGMENT_ORIENTATION.SOUTH ||
          precededSegment.orientation === SEGMENT_ORIENTATION.NORTH)
      ) {
        overall.y = 188.2;
      }
      break;
    default:
  }
  return overall;
}

function calculateXOverall(xSequence, isTrackClosed) {
  //console.log("calculateXOverall");
  const formulaX = [];
  xSequence.forEach((s, i) => {
    const precededBySegment = xSequence[i - 1] ? xSequence[i - 1] : null;
    const nextBySegment = xSequence[i + 1] ? xSequence[i + 1] : null;
    let overall = { x: 0, y: 0 };
    if (s.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
      overall = straightPrecedence(s.orientation, precededBySegment, nextBySegment, isTrackClosed);
    } else if (s.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
      overall = angledPrecedence(s.orientation, precededBySegment, nextBySegment, isTrackClosed);
    }
    formulaX.push(overall.x);
  });
  // console.log("X=", formulaX.slice().join("+"), "=", sumArrayReduce(formulaX));
  return formulaX;
}

function calculateYOverall(ySequence, isTrackClosed) {
  // console.log("calculateYOverall");
  const formulaY = [];
  ySequence.forEach((s, i) => {
    const precededBySegment = ySequence[i - 1] ? ySequence[i - 1] : null;
    const nextBySegment = ySequence[i + 1] ? ySequence[i + 1] : null;
    let overall = { x: 0, y: 0 };
    if (s.type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE) {
      overall = straightPrecedence(s.orientation, precededBySegment, nextBySegment, isTrackClosed);
    } else if (s.type === SEGMENT_INF.ANGLED.LOGICAL_TYPE) {
      overall = angledPrecedence(s.orientation, precededBySegment, nextBySegment, isTrackClosed);
    }
    formulaY.push(overall.y);
  });
  // console.log("Y=", formulaY.slice().join("+"), "=", sumArrayReduce(formulaY));
  return formulaY;
}
export const calculateOverallSizes = (pattern, isTrackClosed) => {
  // console.log("calculateOverallSizes", pattern, isTrackClosed);
  const overall = { x: 0, y: 0 };

  if (pattern.length === 0) return overall;

  const xSequence = [];
  const ySequence = [];
  let xSegmentStartIndex = null;
  let xSegmentEndIndex = null;
  let ySegmentStartIndex = null;
  let ySegmentEndIndex = null;

  // console.log(pattern);

  // Searching for xSegmentStartIndex
  xSegmentStartIndex = 0;
  pattern.forEach((segment, i) => {
    if (segment.position.x <= pattern[xSegmentStartIndex].position.x) {
      xSegmentStartIndex = i;
    }
  });
  if (
    pattern[xSegmentStartIndex].type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE &&
    pattern[xSegmentStartIndex + 1] &&
    pattern[xSegmentStartIndex + 1].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE
  )
    xSegmentStartIndex++;

  // Searching for xSegmentEndIndex
  xSegmentEndIndex = 0;
  pattern.forEach((segment, i) => {
    if (segment.position.x > pattern[xSegmentEndIndex].position.x) {
      xSegmentEndIndex = i;
    }
  });
  if (
    pattern[xSegmentEndIndex].type === SEGMENT_INF.STRAIGHT.LOGICAL_TYPE &&
    pattern[xSegmentEndIndex - 1] &&
    pattern[xSegmentEndIndex - 1].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE
  )
    xSegmentEndIndex--;

  // Searching for ySegmentStartIndex
  ySegmentStartIndex = 0;
  for (let i = 0; i < pattern.length; i++) {
    if (pattern[i].position.z > pattern[ySegmentStartIndex].position.z) {
      ySegmentStartIndex = i;
      break;
    }
  }
  if (pattern[ySegmentStartIndex - 1] && pattern[ySegmentStartIndex - 1].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE)
    ySegmentStartIndex--;

  // Searching for ySegmentEndIndex
  ySegmentEndIndex = 0;
  pattern.forEach((segment, i) => {
    if (i >= ySegmentStartIndex) {
      if (segment.position.z > pattern[ySegmentEndIndex].position.z) {
        ySegmentEndIndex = i;
      }
    }
  });
  if (pattern[ySegmentEndIndex - 1] && pattern[ySegmentEndIndex - 1].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE)
    ySegmentEndIndex--;
  if (pattern[ySegmentEndIndex + 1] && pattern[ySegmentEndIndex + 1].type === SEGMENT_INF.ANGLED.LOGICAL_TYPE)
    ySegmentEndIndex++;

  // console.log("xSegmentStartIndex:", xSegmentStartIndex, "xSegmentEndIndex:", xSegmentEndIndex);
  // console.log("ySegmentStartIndex:", ySegmentStartIndex, "ySegmentEndIndex:", ySegmentEndIndex);
  // X sequence separation
  if (xSegmentStartIndex > xSegmentEndIndex) {
    for (let i = xSegmentStartIndex; i <= pattern.length - 1; i++) {
      xSequence.push(pattern[i]);
    }
  }
  for (let i = 0; i <= xSegmentEndIndex; i++) {
    xSequence.push(pattern[i]);
  }

  // Y sequence separation
  for (let i = ySegmentStartIndex; i <= ySegmentEndIndex; i++) {
    ySequence.push(pattern[i]);
  }
  // console.log("xSequence:", xSequence);
  // console.log("ySequence:", ySequence);

  // Settings final values
  overall.x = sumArrayReduce(calculateXOverall(xSequence, isTrackClosed));
  overall.y = sumArrayReduce(calculateYOverall(ySequence, isTrackClosed));

  // console.log("overall:", overall);

  return overall;
};

export const getPatternMinMaxVector = (pattern) => {
  const vector = { min: { x: 0, y: 0, z: 0 }, max: { x: 0, y: 0, z: 0 } };
  for (let i = 0; i < pattern.length; i++) {
    // vector.min
    if (pattern[i].position.x < vector.min.x) vector.min.x = pattern[i].position.x;
    if (pattern[i].position.y < vector.min.y) vector.min.y = pattern[i].position.y;
    if (pattern[i].position.z < vector.min.z) vector.min.z = pattern[i].position.z;
    // vector.max
    if (pattern[i].position.x > vector.max.x) vector.max.x = pattern[i].position.x;
    if (pattern[i].position.y > vector.max.y) vector.max.y = pattern[i].position.y;
    if (pattern[i].position.z > vector.max.z) vector.max.z = pattern[i].position.z;
  }
  return vector;
};

export const translatePatternToCenter = (pattern) => {
  const tmpPattern = JSON.parse(JSON.stringify(pattern));
  const vector = getPatternMinMaxVector(pattern);
  // Translate to right
  for (let i = 0; i < pattern.length; i++) {
    tmpPattern[i].position.x -= vector.min.x;
    //tmpPattern[i].position.y -= vector.min.y;
    tmpPattern[i].position.z -= vector.min.z;
  }
  // Translate to middle
  for (let i = 0; i < pattern.length; i++) {
    tmpPattern[i].position.x -= (vector.max.x - vector.min.x) / 2;
    //tmpPattern[i].position.y -= (vector.max.y - vector.min.y) / 2;
    tmpPattern[i].position.z -= (vector.max.z - vector.min.z) / 2;
  }
  return tmpPattern;
};

export const getAccessoriesByCr = (accessories, ...crs) => {
  // console.log("getAccessoriesByCr");
  const selectedAccessories = [];
  if (!accessories || crs.length === 0) return selectedAccessories;
  for (let i = 0; i < crs.length; i++) {
    const tmpAcc = accessories.find((acc) => acc.commercialReference === crs[i]);
    if (tmpAcc) selectedAccessories.push({ ...tmpAcc, quantity: 0 });
  }
  return selectedAccessories;
};
export const getAccessoryByCr = (accessories, cr) => {
  // console.log("getAccessoryByCr", accessories, cr);
  const indexOfAcc = accessories.findIndex((a) => a.commercialReference === cr);
  if (indexOfAcc === -1) return null;
  return accessories[indexOfAcc];
};

export const getAccessoryByAccessoryType = (accessories, type) => {
  // console.log("getAccessoryByAccessoryType");
  let accArray = [];
  accessories.forEach((a) => {
    if (a.accessoryType === type) {
      accArray.push(a);
    }
  });
  return accArray;
};

export const getAccessoryByDescriptionKeyword = (accessories, keyWord) => {
  // console.log("getAccessoryByDescriptionKeyword");
  let accObj = {};
  accessories.forEach((a) => {
    if (a.mediumDescription.includes(keyWord)) {
      accObj = { ...a };
    }
  });
  return accObj;
};

export const getAccessoriesByDescriptionKeyword = (accessories, keyWord) => {
  // console.log("getAccessoriesByDescriptionKeyword");
  let accsObj = [];
  accessories.forEach((a) => {
    if (a.mediumDescription.includes(keyWord)) {
      accsObj.push(a);
    }
  });
  return accsObj;
};

export const getPowerSupplyByCr = (powerSupplies, cr) => {
  // console.log("getPowerSupplyByCr");
  return powerSupplies.find((ps) => ps.commercialReference === cr);
};

export const genPowerGroup = (powerSupplies, accessories) => {
  const powerGroup = {
    id: null,
    name: null,
    powerSupply: null,
    connectionModule: null,
    powerCables: null,
    extBrakingResistor: null,
    powerInterPlug: null
  };

  powerGroup.powerSupply = {
    ...getPowerSupplyByCr(powerSupplies, "ABLU3A48200"),
    quantity: 0
  };
  powerGroup.powerInterPlug = {
    ...getAccessoryByDescriptionKeyword(accessories, "power infeed"),
    quantity: 0
  };
  powerGroup.connectionModule = {
    ...getAccessoriesByCr(accessories, "LXMMCACMD02S100")[0],
    quantity: 0
  };
  powerGroup.powerCables = [
    ...getAccessoryByAccessoryType(accessories, "CABLE").map((object) => {
      return { ...object, quantity: 0 };
    })
  ];
  powerGroup.extBrakingResistor = {
    ...getAccessoryByDescriptionKeyword(accessories, "braking resistor"),
    quantity: 0
  };
  return powerGroup;
};

export const genElectricalInstallation = (accessories) => {
  const electricalInstallation = {
    powerDisconnector: null,
    powerInterSeg: null
  };
  electricalInstallation.powerDisconnector = {
    ...getAccessoryByDescriptionKeyword(accessories, "power disconnector"),
    quantity: 0
  };
  electricalInstallation.powerInterSeg = [
    { ...getAccessoryByDescriptionKeyword(accessories, "power interconnect, Lexium MC12, 1 piece"), quantity: 0 },
    { ...getAccessoryByDescriptionKeyword(accessories, "power interconnect, Lexium MC12, 10 piece"), quantity: 0 }
  ];
  return electricalInstallation;
};

export const getNeededPowerGroups = (nbPs) => {
  const neededPowerGroups = [];
  let remainingPs = nbPs;

  while (remainingPs > 0) {
    if (remainingPs >= 3) {
      neededPowerGroups.push(3);
      remainingPs -= 3;
    } else {
      neededPowerGroups.push(remainingPs);
      remainingPs = 0;
    }
  }

  return neededPowerGroups;
};

export const getMaxPowerSupplies = (nbSegments, isTrackClosed) => {
  // console.log("getMaxPowerSupplies");
  if (isTrackClosed) {
    if (nbSegments % 2 === 0) return nbSegments / 2;
    if (nbSegments % 2 !== 0) return nbSegments / 2 - 0.5;
  } else {
    if (nbSegments % 2 === 0) return nbSegments / 2;
    if (nbSegments % 2 !== 0) return nbSegments / 2 + 0.5;
  }
};

export const getMinPowerSupplies = (nbSegments) => {
  // console.log("getMinPowerSupplies");
  return Math.ceil(nbSegments / 24);
};

export const genCommunication = (accessories, nbSegments) => {
  const communication = {
    safetyGroup: null,
    sfoInterconnects: null,
    openSercosSfo: null,
    sfoCables: null,
    sercosInterconnects: null,
    openSercos: null,
    sercosCables: null,
    communicationInterconnects: null,
    sfoCablesView: [],
    sercosCablesView: []
  };
  communication.sfoInterconnects = {
    ...getAccessoryByDescriptionKeyword(accessories, "communication interconnect, Lexium MC12, SFO"),
    quantity: 0
  };
  communication.openSercosSfo = {
    ...getAccessoryByCr(accessories, "LXMMCBDASF1S100"),
    quantity: 0
  };
  communication.sfoCables = [
    ...getAccessoryByAccessoryType(accessories, "PRE-WIRED_CONNECTORS").map((object) => {
      if (object.mediumDescription.includes(" 5 m")) {
        return { ...object, quantity: Math.ceil(nbSegments / 68) };
      }
      return { ...object, quantity: 0 };
    })
  ];
  communication.sercosInterconnects = {
    ...getAccessoryByDescriptionKeyword(accessories, "communication interconnect, Lexium MC12, sercos"),
    quantity: 0
  };
  communication.openSercos = {
    ...getAccessoryByCr(accessories, "LXMMCBDAS01S100"),
    quantity: 0
  };
  communication.sercosCables = [
    ...getAccessoriesByDescriptionKeyword(accessories, "Sercos cable Lexium 62 connection").map((object) => {
      if (object.mediumDescription.includes(" 3 m")) {
        return { ...object, quantity: 2 };
      }
      return { ...object, quantity: 0 };
    })
  ];
  communication.communicationInterconnects = [
    {
      ...getAccessoryByDescriptionKeyword(accessories, "communication interconnect, Lexium MC12, 1 piece"),
      quantity: 0
    },
    {
      ...getAccessoryByDescriptionKeyword(accessories, "communication interconnect, Lexium MC12, 10 pieces"),
      quantity: 0
    }
  ];
  return communication;
};

export function gatherMc12ProductsForBOM(track) {
  // console.log("gatherMc12ProductsForBOM", track);
  const tmpProduct = {};
  // BUILD TRACK
  tmpProduct.buildTrack = [
    track.calculatedSegments.straight,
    track.calculatedSegments.angled,
    ...track.calculatedGuideRails,
    ...track.calculatedCarriers
  ];

  // EI
  tmpProduct.electricalInstallation = [
    { ...track.calculatedElectricalInstallation.powerDisconnector },
    ...track.calculatedElectricalInstallation.powerInterSeg
  ];
  track.calculatedElectricalInstallation?.powerGroups?.forEach((pg) => {
    tmpProduct.electricalInstallation = [
      ...tmpProduct.electricalInstallation,
      { ...pg.powerSupply },
      { ...pg.connectionModule },
      ...pg.powerCables,
      { ...pg.extBrakingResistor },
      { ...pg.powerInterPlug }
    ];
  });
  // COMM
  tmpProduct.communication = [
    { ...track.calculatedCommunication.sfoInterconnects },
    { ...track.calculatedCommunication.openSercosSfo },
    ...track.calculatedCommunication.sfoCables,
    { ...track.calculatedCommunication.sercosInterconnects },
    { ...track.calculatedCommunication.openSercos },
    ...track.calculatedCommunication.sercosCables,
    ...track.calculatedCommunication.communicationInterconnects
  ];
  // ACC
  tmpProduct.accessories = [...track.selectedAccessories];

  // Combine products
  const combinedArray = [
    ...tmpProduct.buildTrack.map((item) => ({ ...item, step: "BuildTrack" })),
    ...tmpProduct.electricalInstallation.map((item) => ({ ...item, step: "ElectricalInstallation" })),
    ...tmpProduct.communication.map((item) => ({ ...item, step: "Communication" })),
    ...tmpProduct.accessories.map((item) => ({ ...item, step: "Accessories" }))
  ];

  return aggregateProductsQuantities(combinedArray);
}

export const calculateNbPsInPowerGroups = (powerGroups) => {
  let nbPs = 0;
  if (powerGroups && powerGroups.length > 0) {
    nbPs = powerGroups.reduce((acc, powerGroup) => (acc += powerGroup.powerSupply.quantity), 0);
  }
  return nbPs;
};

export function serializeObject(obj) {
  // Use JSON.stringify to convert the object to a JSON string
  return JSON.stringify(obj);
}

export function deserializeObject(jsonString) {
  // Use JSON.parse to convert the JSON string back to an object
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error deserializing object:", error);
    return null; // Or return a default value if deserialization fails
  }
}

export const downloadGLTF = (data, outputName = "export") => {
  if (!data) {
    return; // Handle deserialization error
  }

  const blob = new Blob([data], { type: "application/octet-stream" }); // Generic binary stream

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${outputName}.gltf`; // Set a default download filename
  link.click();

  window.URL.revokeObjectURL(url);
};
